import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../index.css";

const AboutDeveloper = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section className="section shadow-sm lazyloaded" id="developer">
      {/* <div className="d-block pt-2 pb-1 text-center">
        <img
          src="images/dosti-westcounty-logo.webp"
          width="auto"
          height="100%"
          loading="lazy"
          alt="Dosti Pine & Willow"
        />
      </div> */}
      <div className="row">
        <div className="col-md-8">
          <h1 class="d-block section-heading color-primary text-capitalize">
            About Developer
          </h1>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right d-none d-lg-block"
            onClick={() => handleShowModal("AboutDev ChatWithUs")}
          >
            Chat with us
          </button>
        </div>
      </div>

      <p>
        With a legacy of over 40 years, Dosti Realty has transformed Mumbai's
        skyline with its landmark residential and commercial projects. With over
        15,800+ happy families, the company is renowned for its timely delivery,
        innovation, and premium developments. Dosti West County is one of its
        most ambitious township projects, designed for a modern, urban
        lifestyle.
      </p>

      <div class="rera-numbers">
        <div class="rera-item">
          <img src="images/pine-rera-P51700025834.PNG" alt="rera qr" />
          <strong>Pine-P51700025834</strong>
        </div>
        <div class="rera-item">
          <img src="images/willow-rera-P51700056278.PNG" alt="rera qr" />
          <strong>Willow-P51700056278</strong>
        </div>
      </div>

      <span className="pro-rera text-center-mob">
        {project} has been registered via MahaRERA registration number and is
        available on the website{" "}
        <a href="https://maharera.mahaonline.gov.in/">
          https://maharera.mahaonline.gov.in/
        </a>{" "}
        under registered projects.
      </span>

      <button
        className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right mx-sm-auto d-lg-none"
        data-form="lg"
        data-title=" Chat with us"
        data-btn=" Chat with us"
        data-enquiry="Download Brochure Left Panel"
        data-redirect="enquiry"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={() => handleShowModal("AboutDev ChatWithUs")}
      >
        Chat with us
      </button>
    </section>
  );
};

export default AboutDeveloper;
